<template>
  <div>

    <tuango-portlet class="box blue">
      <div slot="title" class="portlet-title">
        <div slot="caption" class="caption">
          <i class="icon-link"></i>
          <slot>Orders</slot>
        </div>
        <div slot="actions" class="actions">
        </div>
      </div>
      <div slot="body">
        <tuango-datatables :tableData="orders"
                           :headers="headers"
                           :buttons="buttons"></tuango-datatables>
      </div>
    </tuango-portlet>

    <el-dialog
      title="Send tickets to"
      :visible.sync="dialogVisible"
      @close="email = null; orderId = null"
      width="30%"
      center>
      <input id="customer-email" type="text" v-model="email"/>
      <span slot="footer" class="dialog-footer">
        <button class="btn red btn-outline sbold uppercase" @click="dialogVisible = false">Cancel</button>
        <button class="btn green btn-outline sbold uppercase" @click="resendTickets">Confirm</button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import TuangoDatatables from '@/app/components/datatables/Datatable'
  import TuangoPortlet from '@/app/components/Portlet'

  export default {
    name: 'tbl-orders',
    props: {
      orders: {
        type: Array,
        required: true
      }
    },
    components: {
      TuangoDatatables,
      TuangoPortlet
    },
    data () {
      return {
        dialogVisible: false,
        email: null,
        orderId: null,
        headers: [
          {
            prop: 'id',
            title: 'Order ID'
          },
          {
            prop: 'email',
            title: 'Customer email'
          },
          {
            prop: 'date',
            title: 'Order date'
          },
          {
            prop: 'amount',
            title: 'Order amount'
          },
          {
            prop: 'eventName',
            title: 'Event name'
          },
          {
            prop: 'status',
            title: 'Order status'
          },
          {
            prop: 'actionBtns',
            title: 'Actions'
          },
          {
            prop: 'json',
            title: 'Raw data'
          }
        ],
        buttons: [
          {
            extend: 'copy',
            className: 'dt-button btn default'
          },
          {
            extend: 'print',
            className: 'dt-button btn default'
          },
          {
            extend: 'csv',
            className: 'dt-button btn default'
          }
        ]
      }
    },
    methods: {
      showDialog (e) {
        this.orderId = $(e.target)
          .closest('tr')
          .find('td')
          .eq(0)
          .text()
        this.email = $(e.target)
          .closest('tr')
          .find('td')
          .eq(1)
          .text()

        this.dialogVisible = true
      },
      resendTickets () {
        const url = `https://apigw-${process.env.CLO_PHP_API_ENV}.tuango.ca/lod-outbox-admin/resend-tickets`
        this.$http.get(url + '/' + this.orderId + '/' + encodeURIComponent(this.email))
          .then(res => {
            this.dialogVisible = false
            this.email = null
            this.orderId = null

            this.$notify.success({
              title: 'Success',
              message: 'Email was successfully sent'
            })
          })
          .catch(err => {
            this.dialogVisible = false
            this.email = null
            this.orderId = null

            console.log(err)
            this.$notify.error({
              title: 'Error',
              message: 'Error occured'
            })
          })
      },
      async cancelOrder (e) {
        const orderId = $(e.target)
          .closest('tr')
          .find('td')
          .eq(0)
          .text()

        try {
          await this.$confirm(`Do you want to cancel the order ${orderId}. Continue?`, 'Warning', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning'
          })

          const url = `https://apigw-${process.env.CLO_PHP_API_ENV}.tuango.ca/lod-outbox-admin/cancel-order`
          await this.$http.get(url + '/' + orderId)

          this.$notify.success({
            title: 'Success',
            message: 'Order cancellation was successfully initialized.'
          })
        } catch (err) {
          console.log(err)
          if (err.message) {
            this.$notify.error({
              title: 'Error',
              message: `Error occured.`
            })
          }
        }
      }
    },
    mounted () {
      $('body').on('click', '[data-action="resendTickets"]', this.showDialog)
      $('body').on('click', '[data-action="cancelOrder"]', this.cancelOrder)
    },
    beforeDestroy () {
      $('body').off('click', '[data-action="resendTickets"]', this.showDialog)
      $('body').off('click', '[data-action="cancelOrder"]', this.cancelOrder)
    }
  }
</script>

<style lang="scss" scoped>
  #customer-email {
    width: 100%;
    padding: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/app/components/outbox/OrdersTable.vue